import {
  CreateBookmarkResponse,
  DeleteBookmarkResponse,
  ListBookmarksResponse,
} from '@wix/ambassador-events-schedule-v1-schedule-item/types'
import {addQueryParams} from '@wix/panda-js-utils'
import {ExtendedListScheduleItemsResponse, SchedulePageData} from '@wix/wix-events-commons-statics'
import type {ControllerParams} from '@wix/yoshi-flow-editor'
import {Api as BaseApi} from '../../../../commons/utils/api'

export const createApi = (controllerParams: ControllerParams) => {
  const {api, writeApi} = new BaseApi(controllerParams)

  return {
    getScheduleData: async (params: {
      slug: string
      draftPreviewToken: string
      timeZoneId: string
      language: string
      locale: string
      isEditor: boolean
    }) => api.get<SchedulePageData>(addQueryParams(`/html/schedule-data`, params)),
    getSchedule: (
      eventId: string,
      location: string,
      tags: string[],
      locale: string,
      draft: boolean = false,
    ): Promise<ExtendedListScheduleItemsResponse> =>
      api.get(
        addQueryParams(`/web/events/${eventId}/schedule-items`, {
          stageName: location ? [location] : undefined,
          tag: tags.length ? tags : undefined,
          locale,
          draft: draft ? 'true' : 'false',
        }),
      ),
    getUserProfileImage: (userId: string) => api.get<{imageUrl: string}>(`/web/user/${userId}/profileImage`),
    getBookmarks: (eventId: string): Promise<ListBookmarksResponse> => api.get(`/web/events/${eventId}/bookmarks`),
    createBookmark: (eventId: string, itemId: string): Promise<CreateBookmarkResponse> =>
      writeApi.post(`/web/events/${eventId}/bookmarks/${itemId}`, {}),
    deleteBookmark: (eventId: string, itemId: string): Promise<DeleteBookmarkResponse> =>
      api.delete(`/web/events/${eventId}/bookmarks/${itemId}`),
  }
}

export type Api = ReturnType<typeof createApi>
